import { Phone, MapPin, Award, Facebook, Instagram, Youtube } from "lucide-react";

const SOCIALS = [
  { id: "facebook", href: "https://www.facebook.com/happytiddlers/", label: "Facebook", Icon: Facebook },
  { id: "instagram", href: "http://instagram.com/tiddlertastic", label: "Instagram", Icon: Instagram },
  { id: "youtube", href: "https://www.youtube.com/@happytiddlers1026", label: "YouTube", Icon: Youtube },
];

export function ContactInfo() {
  return (
    <div>
      <span className="text-sm text-[#38BDF8] tracking-[0.2em] uppercase font-bold">Enquire now</span>
      <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
        Ready to make a splash?
      </h2>
      <p className="mt-6 text-lg text-[#94A3B8] leading-relaxed">
        Spaces are limited, especially for Tiddlers over 2½ years. Drop us a
        line and our friendly team will help you find the perfect class.
      </p>
      <div className="mt-10 space-y-4">
        <a href="tel:01582883820" className="flex items-center gap-3 text-[#CBD5E1] hover:text-white transition-colors" data-testid="contact-phone-link">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#FF7A1A]/15 text-[#FF7A1A]"><Phone size={18} /></span>
          <span className="font-semibold">01582 883820</span>
        </a>
        <div className="flex items-center gap-3 text-[#CBD5E1]">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#0EA5E9]/15 text-[#38BDF8]"><MapPin size={18} /></span>
          <span>Barton-le-Clay, Bedfordshire</span>
        </div>
        <div className="flex items-center gap-3 text-[#CBD5E1]">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#0EA5E9]/15 text-[#38BDF8]"><Award size={18} /></span>
          <span>STA 'Swim Star' School · Since 2014</span>
        </div>
      </div>
      <div className="mt-8 flex items-center gap-3" data-testid="contact-socials">
        {SOCIALS.map(({ id, href, label, Icon }) => (
          <a
            key={id}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            data-testid={`contact-social-${id}`}
            className="grid place-items-center w-11 h-11 rounded-xl bg-white/10 text-white hover:bg-[#FF7A1A] hover:-translate-y-0.5 transition-all duration-300"
          >
            <Icon size={20} />
          </a>
        ))}
      </div>
    </div>
  );
}
